import { FC } from 'react';
import s from './sortItem.module.scss';
import cn from 'classnames';
import { Dictionary, useTranslation } from '@hooks/useTranslation';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
interface Props {
  text: Dictionary;
  isIncrease: boolean;
  isActive: boolean;
  onClick: () => Promise<void> | void;
}
export const SortItem: FC<Props> = ({
  isIncrease,
  text,
  onClick
}) => {
  const {
    translate: tr
  } = useTranslation();
  return <button className={cn(s.sortItem, isIncrease && s.sortItem_increase)} onClick={onClick} tabIndex={0} data-sentry-component="SortItem" data-sentry-source-file="SortItem.tsx">
            <span>{tr({
        id: text
      })}</span>
            <SpriteIcon name={'arrow_down'} width={20} height={20} data-sentry-element="SpriteIcon" data-sentry-source-file="SortItem.tsx" />
        </button>;
};